/**
 * ResponsiveDrawer - 通用响应式抽屉组件
 * 移动端从底部弹出，PC端从右侧弹出
 *
 * 使用方法：
 * <responsive-drawer id="MyDrawer">
 *   <div class="responsive-drawer__overlay"></div>
 *   <div class="responsive-drawer__inner">
 *     <div class="responsive-drawer__header">
 *       <h2 class="responsive-drawer__title">标题</h2>
 *       <button class="responsive-drawer__close" aria-label="关闭">
 *         <svg>...</svg>
 *       </button>
 *     </div>
 *     <div class="responsive-drawer__content">
 *       <!-- 内容区域 -->
 *     </div>
 *   </div>
 * </responsive-drawer>
 *
 * 打开抽屉：
 * <button onclick="document.getElementById('MyDrawer').open()">打开</button>
 * 或使用 drawer-opener：
 * <drawer-opener data-drawer="#MyDrawer">
 *   <button>打开</button>
 * </drawer-opener>
 */

class ResponsiveDrawer extends HTMLElement {
  constructor() {
    super();

    this.overlay = this.querySelector('.responsive-drawer__overlay');
    this.closeButton = this.querySelector('.responsive-drawer__close');

    // 绑定关闭事件
    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }

    // ESC 键关闭
    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.triggeredBy = triggeredBy;

    // 添加动画类
    setTimeout(() => {
      this.classList.add('animate', 'active');
    }, 10);

    // 阻止背景滚动
    document.body.classList.add('overflow-hidden');

    // 触发自定义事件
    this.dispatchEvent(new CustomEvent('drawer:opened', {
      bubbles: true,
      detail: { drawer: this }
    }));
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');

    // 触发自定义事件
    this.dispatchEvent(new CustomEvent('drawer:closed', {
      bubbles: true,
      detail: { drawer: this }
    }));

    // 恢复焦点到触发按钮
    if (this.triggeredBy) {
      this.triggeredBy.focus();
      this.triggeredBy = null;
    }
  }

  /**
   * 更新抽屉内容
   * @param {string} html - 新的HTML内容
   */
  updateContent(html) {
    const contentArea = this.querySelector('.responsive-drawer__content');
    if (contentArea) {
      contentArea.innerHTML = html;
    }
  }

  /**
   * 检查抽屉是否打开
   */
  isOpen() {
    return this.classList.contains('active');
  }
}

customElements.define('responsive-drawer', ResponsiveDrawer);

/**
 * DrawerOpener - 抽屉打开器组件
 * 用于触发抽屉打开
 */
class DrawerOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if (!button) return;

    button.addEventListener('click', (e) => {
      e.preventDefault();
      const drawerId = this.getAttribute('data-drawer');
      const drawer = document.querySelector(drawerId);
      if (drawer) {
        drawer.open(button);
      }
    });
  }
}

customElements.define('drawer-opener', DrawerOpener);
